export default __webpack_public_path__ + "static/media/icono-mantencion.ac92b741.png";